import type { DateRange } from 'react-day-picker';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { SingleAccountAnalytics } from '../components/single-account-analytics';
import type { SelectedAccountRef } from '../system-admin-ui-config';

interface AccountDetailDrawerProps {
  account: SelectedAccountRef | null;
  dateRange: DateRange | undefined;
  onClose: () => void;
}

// 90vw right sheet. Uses the app background (not the sheet's translucency) so cards sit on the dashboard surface.
export function AccountDetailDrawer({ account, dateRange, onClose }: AccountDetailDrawerProps) {
  return (
    <Sheet
      open={!!account}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <SheetContent side='right' showClose={false} className='w-[90vw] gap-0 bg-background p-0 backdrop-blur-none sm:max-w-[90vw]'>
        <SheetHeader className='sr-only'>
          <SheetTitle>{account ? (account.name ?? `Account #${account.id}`) : 'Account analytics'}</SheetTitle>
        </SheetHeader>
        <div className='min-h-0 flex-1 overflow-y-auto'>
          {account && (
            <SingleAccountAnalytics
              key={account.id}
              accountId={Number(account.id)}
              accountName={account.name}
              initialDateRange={dateRange}
              onClose={onClose}
            />
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
